<template>
  <div class="content" style="height:100%;">
    <td >
	    <img class :src=" coverUrl?  coverUrl : defaultCoverUrl" style="width:100%;display:block" />
		  <!-- <img class="" src="../../assets/images/logo.png" style="width: 23%;position: absolute;top: -12px;left: 11px;z-index: 2;"/> -->
		</td>
    <!-- <img class="banner" src="../../assets/images/banner.png" /> -->

    <div class="card">
      <div class="footer-top" style="height:35px;"></div>
      <img class="success" src="../../assets/images/success.png" />
      <div class="footer">提交成功</div>
    </div>
  </div>
</template>

<script>
import API from '@/api/common';
export default {
  name: "success",
  data() {
    return {
      openid: this.$route.query.openid,
      hospitalId: this.$route.query.hospitalId,
      examId: this.$route.query.examId,
      coverUrl: '',
      defaultCoverUrl: require('../../assets/images/top.jpg')
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getHospital(this.hospitalId)
    },
    getHospital(hospitalId) {
      API.getHospital(hospitalId).then(result => {
        this.coverUrl = result.data.coverUrl
        this.name = result.data.name
      })
    }
  }
  
};
</script>

<style lang="less" scoped>
.content {
  background-color: #fff;
  .banner {
    width: 100%;
    height: auto;
  }

  .card {
    position: relative;
    // top: -175px;
    // width: 90%;
    margin-bottom: 30px;
    height: 60vh;
    margin: 0 auto;
    border-radius: 6px;

    .title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      margin: 20px auto;
    }

    .success {
      display: block;
      width: 50%;
      height: auto;
      margin: 40px auto;
    }

    .footer {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
